import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {AbstractControl, ControlContainer, FormGroupDirective, ReactiveFormsModule} from "@angular/forms";
import {appendErrorInfos, ValidationMessage} from "../../../structure/validation-message/validation-message";
import {ValidationMessageComponent} from "../../../structure/validation-message/validation-message.component";
import {I18NextPipe} from "@kokos-i18next";
import {WarningMessageComponent} from "../../../structure/warning-message/warning-message.component";

@Component({
    selector: 'pf-textarea',
    imports: [CommonModule, ReactiveFormsModule, ValidationMessageComponent, I18NextPipe, WarningMessageComponent],
    templateUrl: './textarea.component.html',
    viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class TextareaComponent implements OnInit {

    @Input() name: string;
    @Input() label!: string;
    @Input() controlName!: string;
    @Input() required = true;
    @Input() maxLetters = 1000;
    @Input() rows = 8;
    @Input() validate = false;
    @Input() placeholder = '';
    @Input() validationMessages: ValidationMessage[] = []; // all validationmessages attached to the control

    control: AbstractControl;

    textTooLongOnPaste = false;

    private readonly parentFormGroup = inject(FormGroupDirective);

    ngOnInit(): void {
        this.control = this.parentFormGroup.form.get(this.controlName);
    }

    get currentLength(): number {
        const control = this.parentFormGroup.form.get(this.controlName);
        return control?.value ? control.value.length : 0;
    }

    hasAlerts():boolean{
        return this.hasErrors() || this.hasWarnings();
    }

    hasErrors(): boolean {
        return this.validate && !!this.control?.errors;
    }

    hasWarnings(): boolean {
        return this.textTooLongOnPaste;
    }

    getAlertClass(): string | null {
        if (this.hasErrors()) {
            return 'ba-error';
        }
        if (this.hasWarnings()) {
            return 'ba-warning';
        }
        return null;
    }

    inputLostFocus(): void {
        if (this.control.value) {
            this.control.setValue((this.control.value as string).trim());
        }
    }

    getRelevantErrorMessage(): ValidationMessage[] {
        const errors = this.control?.errors;
        if (!errors) return [];
        return this.validationMessages
            .filter(vm => vm.key in errors)
            .map(vm => appendErrorInfos(vm, errors));
    }

    onBeforeInput(e: InputEvent): void {
        if (e.inputType === 'insertFromPaste') {
            const pasted = e.data ?? '';
            this.textTooLongOnPaste = pasted.length > this.maxLetters;
            return;
        }
        this.textTooLongOnPaste = false;
    }

}